import { render, staticRenderFns } from "./AdminCorrectiveActionDetail.vue?vue&type=template&id=4e2e8cd6&scoped=true"
import script from "./AdminCorrectiveActionDetail.vue?vue&type=script&lang=js"
export * from "./AdminCorrectiveActionDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminCorrectiveActionDetail.vue?vue&type=style&index=0&id=4e2e8cd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e8cd6",
  null
  
)

export default component.exports